import { RestLayoutService } from '@sitecore-jss/sitecore-jss-react'
import config from '../temp/config'

export class LayoutServiceFactory {
  create() {
    return new RestLayoutService({
      apiHost: config.sitecoreApiHost,
      apiKey: config.sitecoreApiKey,
      siteName: config.siteName,
      //This is mandatory since we use SXA in Sitecore CMS.
      configurationName: 'sxa-jss',
    })
  }
}

export const layoutServiceFactory = new LayoutServiceFactory()
